/**
 * Environment variables exported from a module where import.meta.env is properly injected.
 * This ensures env vars are accessible even in files loaded early in the module graph.
 */

// Export individual env vars
export const VITE_BACKEND_BASE_URL = import.meta.env.VITE_BACKEND_BASE_URL;
export const VITE_LOGGING = import.meta.env.VITE_LOGGING;
export const VITE_TIMEOUT_MS = import.meta.env.VITE_TIMEOUT_MS;
// Single switch for the whole "Risques Conformité" domain (composite verdict + EDD).
export const VITE_USE_MOCK_COMPLIANCE = import.meta.env.VITE_USE_MOCK_COMPLIANCE;
// Legacy flag — still honored as a fallback so the e2e dev server keeps working.
export const VITE_USE_MOCK_SCREENING = import.meta.env.VITE_USE_MOCK_SCREENING;
// Scoring: separate switch for the fiche-360 scoring-explain feature.
export const VITE_USE_MOCK_SCORING = import.meta.env.VITE_USE_MOCK_SCORING;
// KYB entity (Entreprise step) persistence: no real backend contract exists yet
// either (#25202 controller ticket still "New"). Defaults to mock.
export const VITE_USE_MOCK_KYB_ENTITY = import.meta.env.VITE_USE_MOCK_KYB_ENTITY;
// Target of the "Politique Risque" link on the scoring panel; the link is hidden when unset.
export const VITE_RISK_POLICY_URL = import.meta.env.VITE_RISK_POLICY_URL;
// Vite's built-in dev-mode flag; gates UI for filters/fields with no real backend yet.
export const IS_DEV = import.meta.env.DEV;

// Export the full env object for dynamic access
export const envVars: Record<string, string | undefined> = {
  VITE_BACKEND_BASE_URL,
  VITE_LOGGING,
  VITE_TIMEOUT_MS,
  VITE_USE_MOCK_COMPLIANCE,
  VITE_USE_MOCK_SCREENING,
  VITE_USE_MOCK_SCORING,
  VITE_USE_MOCK_KYB_ENTITY,
  VITE_RISK_POLICY_URL,
};
